import { Flash } from '@acast/decibel';
import moment from 'moment';
import T from 'prop-types';
import React from 'react';

const EpisodeScheduledAlert = ({ date }) => {
  const publishDate = moment(date);

  return (
    <Flash intent="warning">
      Your episode has been scheduled for release on{' '}
      <strong>{publishDate.format('MMMM Do, YYYY @ LT')}</strong> ({publishDate.fromNow()})
    </Flash>
  );
};

EpisodeScheduledAlert.propTypes = {
  date: T.string.isRequired,
};

export default EpisodeScheduledAlert;
